var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFilter = function SvgFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.776 1.001a.75.75 0 00-.751.749L4 16.75a.75.75 0 101.5.002l.024-15a.75.75 0 00-.75-.75zM10.276 1.001a.75.75 0 00-.751.749l-.024 15a.75.75 0 001.5.002l.024-15a.75.75 0 00-.75-.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97 1.505c-.307-.279-.625-.429-.71-.335L1.156 4.577c-.086.094.093.396.399.675.306.28.624.43.71.335l3.103-3.406c.086-.094-.093-.397-.399-.676zM18.968 13.258c-.306-.279-.623-.429-.709-.335l-3.104 3.407c-.086.094.093.396.4.675.305.28.623.43.709.335l3.104-3.406c.085-.094-.093-.397-.4-.676z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.776 1.001a.75.75 0 00-.751.75l-.024 15a.75.75 0 101.5.002l.024-15A.75.75 0 0015.776 1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/filter.0979961a.svg";
export { ForwardRef as ReactComponent };